import { Box, formHelperTextClasses, inputBaseClasses, inputLabelClasses, styled } from '@mui/material';
import { TimeField, TimeFieldProps } from '@mui/x-date-pickers/TimeField';
import { fullTimePattern } from '@oneview/constants/datePattern';
import { Field, FieldProps } from 'formik';
import { get } from 'lodash';
import { FC } from 'react';

const Container = styled(Box)(({ theme }) => ({
    [`.${inputLabelClasses.root}`]: {
        transform: 'translate(14px, 9px) scale(1) !important',
    },
    [`.${inputLabelClasses.shrink}`]: {
        transform: 'translate(14px, -9px) scale(0.75) !important',
    },
    [`.${formHelperTextClasses.root}`]: {
        color: theme.palette.error.main,
    },
    [`.${inputBaseClasses.disabled}`]: {
        cursor: 'not-allowed',
    },
}));

export interface FormTimeFieldProps extends Partial<TimeFieldProps<Date>> {
    name: string;
    validate?: (value: string) => string | undefined;
}

export const FormTimeField: FC<FormTimeFieldProps> = ({ name, validate, ...rest }) => {
    return (
        <Container>
            <Field name={name} validate={validate}>
                {({ field, form: { setFieldValue, touched, errors } }: FieldProps) => {
                    const error = get(touched, field.name) && (get(errors, field.name) as string);

                    return (
                        <TimeField
                            size="small"
                            format={fullTimePattern}
                            {...rest}
                            {...field}
                            onChange={(date, context) => {
                                rest.onChange?.(date, context);

                                if (date) {
                                    setFieldValue(name, date);
                                } else {
                                    setFieldValue(name, null);
                                }
                            }}
                            InputProps={{
                                error: !!error,
                            }}
                            InputLabelProps={{ error: !!error && !rest.disabled }}
                            helperText={error ?? rest.helperText}
                        />
                    );
                }}
            </Field>
        </Container>
    );
};
